// GlowCipher Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile nav toggle ----
  const toggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      const isOpen = mobileNav.classList.contains('open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  // ---- Accordion ----
  document.querySelectorAll('.accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- Product image gallery ----
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-main-image img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.querySelector('img').src;
    });
  });

  // ---- Quantity input ----
  const qtyInput = document.querySelector('.qty-value');
  document.querySelector('.qty-minus')?.addEventListener('click', function () {
    if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
  });
  document.querySelector('.qty-plus')?.addEventListener('click', function () {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  // ---- Email form ----
  const emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = emailForm.querySelector('input[type="email"]');
      const btn = emailForm.querySelector('button');
      if (input && btn) {
        btn.textContent = 'You\'re in! ✓';
        btn.disabled = true;
        input.value = '';
      }
    });
  }

});
